import createFormStyle from 'forms-utils-lib/formStyle/utils/createFormStyle';
const parseStyle = style => {
  if (style) {
    return createFormStyle(JSON.parse(style));
  }
  return createFormStyle({});
};
export default parseStyle;